import React from "react";
import { TopPerformers } from "../charts/TopPerformers";

export const ExecutiveLeaderboard: React.FC = () => {
  return <TopPerformers />;
};
